import {
  clearOnLoadBeacon,
  clearOnViewBeacon,
} from "../../store/actionCreators";
import { getAdvertisementsAnalytics } from "../../../selectors";

export const sendPlacementOnViewBeacon = () => (dispatch, getState) => {
  const state = getState();
  const advertisementsAnalytics = getAdvertisementsAnalytics(state);
  const onViewBeacon = advertisementsAnalytics?.placementBeacons?.onViewBeacon;

  if (onViewBeacon) {
    navigator.sendBeacon(onViewBeacon);
    dispatch(clearOnViewBeacon());
  }
};

export const sendPlacementOnLoadBeacon = () => (dispatch, getState) => {
  const state = getState();
  const advertisementsAnalytics = getAdvertisementsAnalytics(state);
  const onLoadBeacon = advertisementsAnalytics?.placementBeacons?.onLoadBeacon;

  if (onLoadBeacon) {
    navigator.sendBeacon(onLoadBeacon);
    dispatch(clearOnLoadBeacon());
  }
};
